import styled from 'styled-components';

export const CollapseWrapper = styled.div<{ duration: string }>`
  transition: height ${({ duration }) => duration} cubic-bezier(0.4, 0, 0.2, 1);
`;
